const activityPolicies = {
  Activity: {
    //  We need to distinguish components to keep cache consistency
    keyFields: ['id', 'lang'],
  },
  // Guarantee uniqueness since multiple activities can have the same id if imported multiple times
  ChainStepActivity: {
    keyFields: ['id', 'pointPosition'],
  },
};

export default activityPolicies;
